<select id="camera-select"></select>

<div class="flex mob-col">
    <div class="flex-item">
        <div class="capture-container">
            <video #video width="360" height="480" autoplay></video>
        </div>

        <div id="controls" class="butons">
            <button id="capture" (click)="captureImage()" i18n>Capturar</button>
            <button id="clear" (click)="clearStripes()" i18n>Limpar</button>
            <button id="dataCapture" i18n>Enviar para DataCapture</button>
        </div>
    </div>

    <div id="capture_image">
        <canvas #drawCanvas class="drawCanvas"></canvas>
        <canvas #canvas id="canvas"></canvas>
    </div>
</div>
